import React from 'react'
import { DatePicker, type DatePickerMode } from './date-picker'

type Props = {
 id?: string
 value: string
 onChange: (value: string) => void
 placeholder?: string
 disabled?: boolean
 required?: boolean
 mode?: DatePickerMode
 clearable?: boolean
 className?: string
 'aria-label'?: string
}

export function DateField({
 id,
 value,
 onChange,
 placeholder,
 disabled,
 required,
 mode = 'single',
 clearable = true,
 className,
 'aria-label': ariaLabel,
}: Props) {
 return (
 <div>
 <DatePicker
 id={id}
 value={value || null}
 onChange={(v) => onChange(v || '')}
 placeholder={placeholder}
 disabled={disabled}
 mode={mode}
 clearable={clearable}
 className={className}
 aria-label={ariaLabel}
 />
 {required ? <input tabIndex={-1} className="sr-only" value={value || ''} required readOnly /> : null}
 </div>
 )
}

